export default __webpack_public_path__ + "static/media/BottomSheetIcon.2b86ea90.svg";